import KioskContainersContainer from './kiosk-containers-container';

export default KioskContainersContainer;
